import { render, staticRenderFns } from "./RightOrWrongIcons.vue?vue&type=template&id=67f88f1b&"
import script from "./RightOrWrongIcons.vue?vue&type=script&lang=js&"
export * from "./RightOrWrongIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports